export default {
  "mainVegetable": "groentsager",
  "mainVegetable/01": "groentsager/auberginer",
  "mainVegetable/02": "groentsager/asparges",
  "mainVegetable/03": "groentsager/avocado",
  "mainVegetable/04": "groentsager/rodbeder",
  "mainVegetable/05": "groentsager/broccoli",
  "mainVegetable/06": "groentsager/gulerodder",
  "mainVegetable/07": "groentsager/selleri",
  "mainVegetable/08": "groentsager/champignoner",
  "mainVegetable/09": "groentsager/kal",
  "mainVegetable/10": "groentsager/rosenkal",
  "mainVegetable/11": "groentsager/kinakal",
  "mainVegetable/12": "groentsager/blomkal",
  "mainVegetable/13": "groentsager/coleslaw",
  "mainVegetable/14": "groentsager/agurker",
  "mainVegetable/15": "groentsager/squash",
  "mainVegetable/16": "groentsager/endivier",
  "mainVegetable/17": "groentsager/spinater",
  "mainVegetable/18": "groentsager/hestebonner",
  "mainVegetable/19": "groentsager",
  "mainVegetable/20": "groentsager",
  "mainVegetable/21": "groentsager/torrede-bonner",
  "mainVegetable/22": "groentsager/haricots-verts",
  "mainVegetable/23": "groentsager/linser",
  "mainVegetable/24": "groentsager/grontsagsblanding",
  "mainVegetable/25": "groentsager/majs",
  "mainVegetable/26": "groentsager/salatmix",
  "mainVegetable/27": "groentsager/majroe",
  "mainVegetable/28": "groentsager/log",
  "mainVegetable/29": "groentsager/edamamebonner",
  "mainVegetable/30": "groentsager/peberfrugter",
  "mainVegetable/31": "groentsager/kartofler",
  "mainVegetable/32": "groentsager/bonnespirer",
  "mainVegetable/33": "groentsager/radiser",
  "mainVegetable/34": "groentsager/bladsalat",
  "mainVegetable/35": "groentsager/krollet-salat",
  "mainVegetable/36": "groentsager/iceberg-salat",
  "mainVegetable/37": "groentsager",
  "mainVegetable/38": "groentsager/rissalat",
  "mainVegetable/39": "groentsager/romainesalat",
  "mainVegetable/40": "groentsager",
  "mainVegetable/41": "groentsager/salat",
  "mainVegetable/42": "groentsager/feldsalat",
  "mainVegetable/43": "groentsager/rucola",
  "mainVegetable/44": "groentsager",
  "mainVegetable/45": "groentsager",
  "mainVegetable/46": "groentsager/tomater",
  "mainVegetable/47": "groentsager/butter-beans",
  "mainVegetable/48": "groentsager/kikaerter",
  "mainVegetable/49": "groentsager/porrer",
  "mainVegetable/50": "groentsager/graeskar",
  "mainVegetable/51": "groentsager/rode-kidneybonner",
  "mainVegetable/52": "groentsager/aebler",
  "mainVegetable/53": "groentsager/kastanjer",
  "mainVegetable/54": "groentsager/blommer",
  "mainVegetable/55": "groentsager",
  "mainVegetable/56": "groentsager/sorte-oliven",
  "mainVegetable/57": "groentsager/artiskokker",
  "mainVegetable/58": "groentsager/rode-peberfrugter",
  "mainVegetable/59": "groentsager",
  "mainVegetable/60": "groentsager",
  "mainVegetable/61": "groentsager/ratatouille",
  "mainVegetable/62": "groentsager/couscous",
  "mainVegetable/63": "groentsager",
  "mainVegetable/64": "groentsager",
  "mainVegetable/65": "groentsager",
  "mainVegetable/66": "groentsager",
  "mainVegetable/67": "groentsager/rode-linser",
  "mainVegetable/68": "groentsager/quinoa",
  "mainVegetable/69": "groentsager/spelt",
  "mainVegetable/70": "groentsager/bulgur",
  "mainVegetable/71": "groentsager/rodkal",
  "mainVegetable/72": "groentsager/gronkal",
  "mainVegetable/73": "groentsager/korvel",
  "mainVegetable/74": "groentsager",
  "mainVegetable/75": "groentsager/baelgfrugter",
  "mainVegetable/76": "groentsager/sode-kartofler",
  "mainVegetable/77": "groentsager/graeskar",
  "mainVegetable/78": "groentsager",
  "mainVegetable/79": "groentsager/bonner",
  "mainVegetable/80": "groentsager/aerter-og-karotter",
  "mainVegetable/81": "groentsager/aerter",
  "mainVegetable/82": "groentsager/edamamebonner",
  "mainVegetable/83": "groentsager",
  "mainVegetable/84": "groentsager",
  "mainVegetable/85": "groentsager",
  "mainVegetable/86": "groentsager",
  "mainVegetable/87": "groentsager",
  "mainVegetable/88": "groentsager",
  "mainVegetable/89": "groentsager",
  "mainVegetable/90": "groentsager/pastinak",
  "mainVegetable/91": "groentsager",
  "mainVegetable/92": "groentsager/boennemix",
  "mainVegetable/93": "groentsager/sorte-boenner",
  "mainVegetable/94": "groentsager/spidskaal",
  "mainVegetable/95": "groentsager/hvide-boenner",
  "mainVegetable/96": "groentsager",
  "mainVegetable/97": "groentsager",
  "mainVegetable/98": "groentsager",
  "season": "arstid",
  "season/1": "arstid/sommer",
  "season/2": "arstid/efterar",
  "season/3": "arstid/vinter",
  "season/4": "arstid/forar",
  "season/5": "arstid",
  "technologie": "teknologi",
  "technologie/AC01": "teknologi/konserves",
  "technologie/AD01": "teknologi",
  "technologie/AG01": "teknologi",
  "technologie/AT01": "teknologi",
  "recipeDish": "ret",
  "recipeDish/ACC": "ret/tilbehor",
  "recipeDish/APE": "ret",
  "recipeDish/DES": "ret/dessert",
  "recipeDish/ENT": "ret/forret",
  "recipeDish/PLAT": "ret/hovedret",
  "recipeDish/SAL": "ret/salat",
  "recipeDish/SNA": "ret/snack",
  "recipeDish/PDE": "ret/morgenmad",
  "recipeDish/DEJ": "ret/frokost",
  "recipeDish/TRA": "ret/traditionel",
  "recipeDish/GOU": "ret/gourmet",
  "recipeDish/ETH": "ret/etnisk",
  "recipeDish/FCH": "ret/bornevenlig",
  "recipeDish/SOU": "ret",
  "pred-recipeTimingCook-facet": "tilberedningstid",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "tilberedningstid/0-15-minutter",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "tilberedningstid/15-30-minutter",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "tilberedningstid/30-45-minutter",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "tilberedningstid/45-minutter",
  "pred-recipeTimingPreparation-facet": "forberedningstid",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "forberedningstid/0-15-minutter",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "forberedningstid/15-30-minutter",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "forberedningstid/30-45-minutter",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "forberedningstid/45-minutter",
  "pred-recipeCost-Facet": "budget",
  "pred-recipeCost-Facet/petit": "budget/lavt",
  "pred-recipeCost-Facet/moyen": "budget/mellem",
  "pred-recipeCost-Facet/grand": "budget/hojt",
  "recipeDifficulty": "svaerhedsgrad",
  "recipeDifficulty/1": "svaerhedsgrad/let",
  "recipeDifficulty/2": "svaerhedsgrad/medium",
  "recipeDifficulty/3": "svaerhedsgrad/svaer",
  "recipeDishNumber": "antal-portioner",
  "recipeDishNumber/1": "antal-portioner/1",
  "recipeDishNumber/2": "antal-portioner/2",
  "recipeDishNumber/3": "antal-portioner/3",
  "recipeDishNumber/4": "antal-portioner/4",
  "recipeDishNumber/5": "antal-portioner/5",
  "recipeDishNumber/6": "antal-portioner/6",
  "recipeDishNumber/7": "antal-portioner/7",
  "recipeDishNumber/8": "antal-portioner/8",
  "productTheme": "produkt-temaer",
  "productTheme/ACC": "produkt-temaer/tilbehor",
  "productTheme/BEA": "produkt-temaer/baelgfrugter",
  "productTheme/BIS": "produkt-temaer/bonner-i-sauce",
  "productTheme/BIO": "produkt-temaer/oko",
  "productTheme/CAN": "produkt-temaer/konserves",
  "productTheme/CER": "produkt-temaer",
  "productTheme/CLS": "produkt-temaer/klassikere",
  "productTheme/DLE": "produkt-temaer/grontsager",
  "productTheme/EDR": "produkt-temaer/mini-packs",
  "productTheme/ENT": "produkt-temaer/forretter",
  "productTheme/FRZ": "produkt-temaer/frost",
  "productTheme/FSD": "produkt-temaer/salatingredienser",
  "productTheme/FSH": "produkt-temaer",
  "productTheme/ING": "produkt-temaer/ingredienser-til-mine-opskrifter",
  "productTheme/JAR": "produkt-temaer",
  "productTheme/LBW": "produkt-temaer/lunch-bowl",
  "productTheme/LDF": "produkt-temaer/bagte-grontsager",
  "productTheme/LEG": "produkt-temaer/baelgfrugter",
  "productTheme/LGO": "produkt-temaer",
  "productTheme/LGR": "produkt-temaer",
  "productTheme/LGS": "produkt-temaer",
  "productTheme/MAI": "produkt-temaer/majs",
  "productTheme/MUS": "produkt-temaer/champignoner",
  "productTheme/NEW": "produkt-temaer/nyheder",
  "productTheme/PDH": "produkt-temaer",
  "productTheme/PDL": "produkt-temaer",
  "productTheme/PHR": "produkt-temaer",
  "productTheme/PLP": "produkt-temaer/hovedret",
  "productTheme/RAL": "produkt-temaer",
  "productTheme/RDM": "produkt-temaer",
  "productTheme/SAL": "produkt-temaer",
  "productTheme/SDB": "produkt-temaer/salat-bowls",
  "productTheme/SNK": "produkt-temaer",
  "productTheme/SUP": "produkt-temaer/suppe",
  "productTheme/TEX": "produkt-temaer/tex-mex",
  "productTheme/VGP": "produkt-temaer",
  "recipeTheme": "opskriftstema",
  "recipeTheme/01": "opskriftstema/hojtider",
  "recipeTheme/02": "opskriftstema",
  "recipeTheme/03": "opskriftstema/salater-og-snacks",
  "recipeTheme/04": "opskriftstema/supper",
  "recipeTheme/05": "opskriftstema",
  "recipeTheme/06": "opskriftstema",
  "recipeTheme/07": "opskriftstema/desserter",
  "recipeTheme/08": "opskriftstema/vegetarisk-mad",
  "recipeTheme/09": "opskriftstema/tilbehor",
  "recipeTheme/10": "opskriftstema",
  "recipeTheme/11": "opskriftstema",
  "recipeTheme/12": "opskriftstema",
  "recipeTheme/13": "opskriftstema/snacks-og-fingerfood",
  "recipeTheme/14": "opskriftstema/hovedretter",
  "recipeTheme/15": "opskriftstema/desserter-og-bagvaerk",
  "recipeTheme/16": "opskriftstema/forretter-og-supper",
  "recipeTheme/17": "opskriftstema/salater",
  "recipeTheme/18": "opskriftstema/bowls",
  "recipeTheme/19": "opskriftstema/supper",
  "recipeTheme/20": "opskriftstema",
  "recipeTheme/21": "opskriftstema/sovser",
  "recipeTheme/22": "opskriftstema",
  "recipeTheme/23": "opskriftstema/andre-retter",
  "recipeTheme/24": "opskriftstema/ovnbagte-retter",
  "recipeTheme/25": "opskriftstema",
  "recipeTheme/26": "opskriftstema",
  "recipeTheme/27": "opskriftstema",
  "recipeTheme/28": "opskriftstema",
  "recipeTheme/33": "opskriftstema",
  "recipeTheme/34": "opskriftstema",
  "recipeTheme/35": "opskriftstema",
  "recipeTheme/36": "opskriftstema",
  "recipeTheme/37": "opskriftstema",
  "recipeTheme/38": "opskriftstema",
  "recipeTheme/39": "opskriftstema",
  "recipeTheme/40": "opskriftstema",
  "recipeTheme/41": "opskriftstema",
  "recipeTheme/42": "opskriftstema",
  "recipeTheme/43": "opskriftstema",
  "recipeTheme/44": "opskriftstema",
  "recipeTheme/45": "opskriftstema",
  "recipeTheme/46": "opskriftstema",
  "pred-particularite": "kategorier",
  "pred-particularite/Sans%20conservateur": "kategorier/uden-konserveringsmidler",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "kategorier",
  "pred-particularite/Sans%20colorant": "kategorier/uden-farvestoffer",
  "pred-particularite/Sans%20sucre%20ajout%E9": "kategorier/uden-tilsat-sukker",
  "pred-particularite/Sans%20sel%20ajout%E9": "kategorier/uden-tilsat-salt",
  "pred-particularite/Sans%20additif": "kategorier/uden-tilsaetningsstoffer",
  "pred-particularite/": "kategorier/med-et-naturligt-indhold-af-salt",
  "pred-particularite/Sans%20lactose": "kategorier/laktose-fri",
  "pred-particularite/Sans%20gluten": "kategorier/gluten-fri",
  "pred-particularite/V%E9g%E9tarien": "kategorier/vegetarisk",
  "pred-particularite/V%E9g%E9talien": "kategorier/vegansk",
  "pred-particularite/Sans%20sulfite": "kategorier",
  "pred-particularite/A%20la%20vapeur": "kategorier",
  "pred-particularite/Sans%20condiment": "kategorier",
  "cultureType": "vis-kun",
  "cultureType/Bio": "vis-kun/oko",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "vis-kun/ingen-pesticidrester",
  "cultureType/Sans%20OGM": "vis-kun/gmo-fri",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "kategorier/vegansk",
  "pred-particularite/recipeVeggie": "kategorier/vegetarisk",
  "pred-particularite/recipeGlutenfree": "kategorier/glutenfri",
  "pred-particularite/recipeLactosefree": "kategorier/laktosefri"
};
